import { usePlanWizardStore } from '@/stores/usePlanWizardStore'
import { useHierarchyFromPlan } from '@/hooks/useHierarchy'
import { PlanSearcher } from './PlanSearcher'
import { PlanPreview } from './PlanPreview'
import { StepHeader } from './StepHeader'
import type { SearchablePlan } from '@/api/planSearch'

export function SourceSelectionStep() {
  const {
    selectedSourcePlan,
    showPlanPreview,
    setSelectedSourcePlan,
    clearSourceSelection,
  } = usePlanWizardStore()

  // Auto-populate hierarchy when source plan is selected
  useHierarchyFromPlan(selectedSourcePlan?.hierarchyId)

  // Show preview if a plan is selected
  if (showPlanPreview && selectedSourcePlan) {
    return (
      <div className="flex flex-col gap-6 w-full">
        {/* Header */}
        <StepHeader
          title="Source Plan Selected"
          description="Review the source plan details and items below"
        />

        {/* Plan Preview */}
        <PlanPreview
          plan={selectedSourcePlan}
          onChangeSource={clearSourceSelection}
        />
      </div>
    )
  }

  // Show search view
  return (
    <div className="flex flex-col gap-6 w-full">
      {/* Header */}
      <StepHeader
        title="Select Source Plan"
        description="Search for an existing plan to copy from"
      />

      {/* Search Card */}
      <div className="bg-white p-6 rounded-[12px] border border-[#D6DAE1] shadow-[0px_1px_2px_0px_rgba(0,0,0,0.09)]">
        <h3 className="text-[16px] font-semibold text-[#1C1C1C] mb-4">
          Search Plans
        </h3>
        <PlanSearcher
          onSelect={(plan: SearchablePlan) => setSelectedSourcePlan(plan)}
          placeholder="Search plans by name"
        />
        <p className="text-[13px] text-[#556374] mt-3">
          Start typing to search for plans. Results will filter based on your
          selected plan type.
        </p>
      </div>
    </div>
  )
}
